export default "__VITE_ASSET__Bj9cP$T7__"